export default __webpack_public_path__ + "media/images/word_new-9887797c46afb4be96e07be32fbecb6d.png";